import { render, staticRenderFns } from "./SearchFieldSuggestion.vue?vue&type=template&id=6b1e74e3"
import script from "./SearchFieldSuggestion.vue?vue&type=script&lang=js"
export * from "./SearchFieldSuggestion.vue?vue&type=script&lang=js"
import style0 from "./SearchFieldSuggestion.vue?vue&type=style&index=0&id=6b1e74e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports